<template>
  <v-list dense>
    <template v-for="item in filteredItems">
      <v-list-item
          :key="item.text"
          link
          :to="item.to || '/'"
      >
        <v-list-item-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ item.text }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-list>
</template>

<script>
export default {
  name: "drawerList",
  computed: {
    filteredItems () {
      const homeRoute = this.$router.options.routes[0] || {}
      const routes = homeRoute.children || []
      // 라우터 기준
      return routes.filter(({meta}) => {
        const menu = meta?.menu || {}
        return meta?.menu && (!menu.hide || (typeof menu.hide === 'function' && !menu.hide.call(this)))
      }).map((route) => ({
        icon: route.meta?.menu?.icon,
        text: route.meta?.menu?.text || route.name,
        to: route
      }))
    },
  }
}
</script>

<style scoped>

</style>